import SharedGlobalStyles from '@helios/shared/styles/shared-global-styles'

import '@reach/accordion/styles.css'
import '@reach/combobox/styles.css'
import '@reach/slider/styles.css'
import 'gatsby-plugin-prismic-previews/dist/styles.css'
import 'pure-react-carousel/dist/react-carousel.es.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default SharedGlobalStyles
